declare namespace $ {

	type $mol_link__arg_shm_hitalama_components_tests_detail_1 = $mol_type_enforce<
		({ 
			'application_test': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_components_tests_detail_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_select__value_shm_hitalama_components_tests_detail_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['selected_run'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_components_tests_detail_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['run_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_text__text_shm_hitalama_components_tests_detail_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['summary'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_labeler__title_shm_hitalama_components_tests_detail_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_components_tests_detail_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['Run_select'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_paginator__page_shm_hitalama_components_tests_detail_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['run_page'] >
		,
		ReturnType< $shm_paginator['page'] >
	>
	type $shm_paginator__total_shm_hitalama_components_tests_detail_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['run_total'] >
		,
		ReturnType< $shm_paginator['total'] >
	>
	type $shm_paginator__page_size_shm_hitalama_components_tests_detail_10 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_paginator['page_size'] >
	>
	type $mol_view__sub_shm_hitalama_components_tests_detail_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_components_tests_detail_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_tests_detail['report'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_components_tests_detail_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_components_tests_detail extends $mol_page {
		status_kind( ): string
		Close_icon( ): $mol_icon_close
		Close( ): $mol_link
		content_rows( ): readonly(any)[]
		summary( ): string
		selected_run( next?: string ): string
		run_options( ): Record<string, any>
		Run_select( ): $mol_select
		run_page( next?: number ): number
		run_total( ): number
		status_label( ): string
		report( ): string
		definition( ): $shm_hitalama_map_widget_entity_custom
		selected( ): string
		minimal_width( ): number
		attr( ): ({ 
			'test_status': ReturnType< $shm_hitalama_components_tests_detail['status_kind'] >,
		})  & ReturnType< $mol_page['attr'] >
		tools( ): readonly(any)[]
		body( ): ReturnType< $shm_hitalama_components_tests_detail['content_rows'] >
		Summary( ): $mol_text
		Runs( ): $mol_labeler
		Run_pages( ): $shm_paginator
		Result_status( ): $mol_view
		Report( ): $mol_text
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=detail.view.tree.d.ts.map